import * as types from './actionTypes';

const initialState = {
    actions:[],
    deletedActions:[]
}

const reducer = (state = initialState , action) => {

    switch(action.type){

        case types.ADD:
            console.log('adding action')
            return {
                ...state,
                actions:[...state.actions,action.cardActionToAdd]
            };

        case types.UPDATE:
            console.log('update actionnnnnnnnnnnnnnnnnnnnnnnnnnn')
            console.log(state)
            return {
                ...state,
                actions: [...state.actions.map(a => {
                    if(a.position!==action.cardAction.position){
                        return a;
                    }
                    else{
                        return Object.assign(action.cardAction);
                    }
                })]
            }
            
        case types.REMOVE:
            return {
                ...state,
                actions: state.actions.filter(a => a.position !== action.position),
                deletedActions: [...state.deletedActions,action.cardActionId]
            };

        case types.SET:
            console.log('set actions')
            return {
                ...state,
                actions: action.cardActions
                .map((a,index) => {
                    a.position = index;
                    return a;
                })
            }

        default: 
            return state;
        }

}

export default reducer;